/**
 * Product JSON-LD for real /product/:id pages only.
 * No aggregateRating — ratings are not a first-party feed here.
 */

const SITE = 'https://nannybbakery.ca';

export function productPageUrl(id: string): string {
  return `${SITE}/product/${id}`;
}

export function buildProductSchemaData({
  id,
  name,
  description,
  price,
  image,
  isAvailable = true,
  category,
}: {
  id: string;
  name: string;
  description?: string;
  price: number;
  image?: string;
  isAvailable?: boolean;
  category?: string;
}) {
  const url = productPageUrl(id);
  return {
    '@id': url,
    url,
    name,
    description: description || name,
    image: image || `${SITE}/assets/images/exterior/storefront-exterior.webp`,
    brand: {
      '@type': 'Brand',
      name: "Nanny B's Bakery",
    },
    category: category || 'Bakery',
    offers: {
      '@type': 'Offer',
      url,
      price: price.toFixed(2),
      priceCurrency: 'CAD',
      availability: isAvailable
        ? 'https://schema.org/InStock'
        : 'https://schema.org/OutOfStock',
      seller: {
        '@type': 'Organization',
        name: "Nanny B's Bakery",
      },
    },
  };
}
